export default __webpack_public_path__ + "static/media/generic_tag.d6746fa3.svg";